import { Link } from "react-router-dom";

export default function AdminMenu(){

return(

<div className="admin-header">

<div className="admin-title">
Admin Panel
</div>

<div className="admin-nav">

<Link to="/admin">Dashboard</Link>
<Link to="/create-user">Create User</Link>
<Link to="/users">User Management</Link>
<Link to="/">Billing System</Link>

</div>

</div>

)

}